import React, { SyntheticEvent, useEffect, useState } from 'react';
import { TableCell, TextField, Alert, TextareaAutosize, Select, Autocomplete } from '@mui/material';

interface AuditComparisonProps {
    originalValue?: string;
    auditValue?: string;
    readonly?: boolean;
    as?: "textarea";
    options?: string[];
    onUpdate: (value: string | number) => void;
}

const AuditComparison: React.FC<AuditComparisonProps> = ({
    originalValue,
    auditValue,
    readonly,
    as,
    options,
    onUpdate,
}) => {

    const [currentAuditValue, setCurrentAuditValue] = useState<string | undefined>(auditValue);
    const [localValue, setLocalValue] = useState<string | undefined>(auditValue);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setLocalValue(e.target.value);
    };

    useEffect(() => {
        const timeoutId = setTimeout(() => {

            if (localValue !== currentAuditValue) {
                setCurrentAuditValue(localValue);
                onUpdate(localValue || '');
            }
        }, 500);

        return () => clearTimeout(timeoutId);
    }, [localValue, currentAuditValue, onUpdate]);

    useEffect(() => {
        setLocalValue(auditValue);
        setCurrentAuditValue(auditValue);
    }, [auditValue, originalValue]);

    return (
        <TableCell style={{ alignContent: 'end' }}>
            {originalValue && (currentAuditValue && currentAuditValue !== '0') ? (
                <>
                    {currentAuditValue.toUpperCase() !== originalValue?.toUpperCase() ? (
                        <Alert severity="error">{originalValue}</Alert>
                    ) : (
                        <Alert severity="success">{currentAuditValue}</Alert>
                    )}
                </>
            ) : (
                <p>{originalValue}</p>
            )}

            {options ? <Autocomplete
                options={['', ...options]}
                value={localValue || ''}
                onInputChange={(event: object, value: string, reason: string) => {
                    setLocalValue(value);
                }}
                renderInput={(params) => <TextField
                    {...params}
                    sx={{mb:1,mt:2} }
                    label="Audit Value"
                    

                />}
            /> :

                as === "textarea" ? (
                    <TextareaAutosize
                        placeholder="Audit Value"
                        minRows={originalValue ? 2 : 4}
                        style={{
                            borderRadius: '5px',
                            borderColor: '#ccc',
                            marginTop: '1.25em',
                            marginBottom:'0',
                            padding: '.5em',
                            width: '100%',
                            minWidth: '160px',
                            opacity: currentAuditValue ? 0.9 : 0.6,
                        }}
                        value={localValue || ''}
                        onChange={handleChange}
                        readOnly={readonly}
                    />
                ) : (
                    <TextField
                        label="Audit Value"
                        value={localValue || ''}
                        onChange={handleChange}
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        disabled={readonly}
                    />
                )}
        </TableCell>
    );
};

export default AuditComparison;
